import React from "react";

const Loader = ({ text = "Loading..." }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-tier-primary dark:bg-tier-primary-dark dark:border-gray-600 border p-6 rounded-xl shadow-lg text-center min-w-[250px] animate-fade-in">
        {/* Spinner */}
        {/* <div className="animate-spin w-16 h-16 border-4 border-t-4 border-gray-200 border-t-teal-500 rounded-full mx-auto" role="status"></div> */}
        <section className="dots-container">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </section>

        {/* Loading Text */}
        <p className="mt-4 text-alt-color font-medium">{text}</p>
      </div>
    </div>
  );
};

export default Loader;
